import { NextPageWithLayout } from 'next';
import React, { ReactElement } from 'react';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import { useIntl } from 'react-intl';
import markdown from '../data/staticPages/fashionunited-career-center.md';
import Layout from '../components/Layout';
import messages from '../lib/messages.json';
import HomeLink from '../components/HomeLink';
import Head from '../components/Head';
import LinkAndAnchor from '../components/LinkAndAnchor';
import Markdown from '../components/Markdown';

const FashionUnitedCareerCenterPage: NextPageWithLayout = () => {
  const intl = useIntl();

  const breadcrumbs = [
    <HomeLink />,
    <LinkAndAnchor
      route="fashionunited-career-center"
      passHref
    >
      {intl.formatMessage(messages['info.features.careerCenter'])}
    </LinkAndAnchor>,
  ];

  return (
    <>
      <Head
        title={intl.formatMessage(messages['info.features.careerCenter'])}
        description={intl.formatMessage(messages['info.features.careerCenter'])}
      />
      <StaticPageComponent
        content={<Markdown markdown={markdown} />}
        title={intl.formatMessage(messages['info.features.careerCenter'])}
        breadcrumbs={breadcrumbs}
      />
    </>
  );
};

FashionUnitedCareerCenterPage.getLayout = (page: ReactElement) => (
  <Layout>
    {page}
  </Layout>
);

export default FashionUnitedCareerCenterPage;
